const showAddedAmountMenuLimitTotalAtSearchGochi =
  process.env.REACT_APP_SHOW_ADDED_AMOUNT_SEARCH_GOCHI === 'true';

export default {
  showAddedAmountMenuLimitTotalAtSearchGochi
};
